import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ND, WidgetValidator} from '@pt/pt-models';
import {ValidatorGenerator} from '../../utils';
import { DocResourceStatus } from 'it/primatoo/openapi/api/org/schemas/common/DocResourceStatus';

@Component({
  selector: 'pt-treatment-input-state',
  templateUrl: './treatment-input-state.component.html',
  styleUrls: ['./treatment-input-state.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TreatmentInputStateComponent),
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TreatmentInputStateComponent),
      multi: true,
    },
  ],
})
export class TreatmentInputStateComponent
  implements OnInit, OnDestroy, ControlValueAccessor, Validator
{
  @Input() controlName: string;
  @Input() label: string;
  @Input() status?: 'DRAFT' | 'PUBLISHED' | 'VALIDATED' | 'ARCHIVED';
  @Input() completed?: boolean;
  @Input() noCompletedMessage: string = '';
  @Input() validators: WidgetValidator[];
  @Input() enabledEdit: boolean;

  d: DocResourceStatus;
  @Output() publicTreatment = new EventEmitter();
  @Output() reopenTreatment = new EventEmitter();

  ND = ND;

  public formGroup: FormGroup;
  isDisabled = false;
  isChanged = false;
  isRequired: boolean;
  inputId: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  ngOnDestroy(): void {
    this.isRequired = ValidatorGenerator.validatorsContainsRequired(
      this.validators
    );

    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.inputId = 'ptWTreatmentInputState_' + this.controlName;

    this.setFormGroup();

    this.formGroup.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((t) => {
        this.isChanged = t.value !== null;

        if (this.onChanged) {
          this.onChanged(t ? t.value : t);
        }
        if (this.onTouched) {
          this.onTouched();
        }
      });
  }

  writeValue(obj: string): void {
    this.formGroup.controls.value.setValue(obj);
  }

  registerOnChange(fn): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.formGroup.controls.value.disable();
    } else {
      this.formGroup.controls.value.enable();
    }
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return (
      this.formGroup.invalid && {
        invalid: true,
      }
    );
  }

  private setFormGroup() {
    this.formGroup = new FormGroup({
      value: new FormControl(null),
    });
  }
}
